var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"canpinBox_one",style:({
		marginBottom:_vm.mabot
	})},[_c('div',{staticClass:"canpinBox_one_one"},[_vm._v(_vm._s(_vm.title))]),(_vm.more)?_c('div',{staticClass:"canpinBox_one_two",on:{"click":_vm.goMore}},[_c('div',[_vm._v(_vm._s(_vm.$t("i18n_75")))]),_vm._m(0)]):_vm._e()])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{attrs:{"src":require("@/assets/index/yjt.png")}})])
}]

export { render, staticRenderFns }